"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Message = require("../ui-components/Message");

var Disabled = function Disabled() {
  return (0, _preact.h)(_Message.Message, {
    customClass: "system-emails-disabled-message",
    variant: "danger",
    text: (0, _preact.h)("div", null, "System emails have currently been paused, which mutes all automated emails (eg. replies, new topics, password resets, registration confirmations, etc.). You can resume emails in ", (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)("/email/system-emails")
    }, "System Emails Settings"), ".")
  });
};

var _default = Disabled;
exports.default = _default;